import { Component, OnInit } from '@angular/core';
import { ButtonStepComponent } from '../../step/button-step/button-step.component';
import { ControlContainer, FormGroupDirective, UntypedFormControl, Validators } from '@angular/forms';

@Component({
    selector: 'app-buying-process',
    templateUrl: '../../step/button-step/button-step.component.html',
    styleUrls: ['./buying-process.component.scss', '../../step/step.component.scss', '../../step/button-step/button-step.component.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
    standalone: false
})
export class BuyingProcessComponent extends ButtonStepComponent implements OnInit {
  title : string = "Where are you in the buying process?";
  buttonList = [
    { text: 'Researching Options', value: 'just_thinking', imageName: 'researching_options' },
    { text: 'Purchase Within 90 Days', value: 'days_from_buying', imageName: 'purchase-within-90', default: true},
    { text: 'Purchase Within 30 Days', value: 'days_from_buying_30', imageName: 'purchase-within-30'},
    { text: 'Found Home', value: 'found_home', imageName: 'found-home'},
    { text: 'Signed Agreement', value: 'signed_agreement', imageName: 'signed-agreement'},
  ];

  ngOnInit() {
    this.control = new UntypedFormControl('', Validators.required);
    this.form.addControl('buyingProcess', this.control);
  }
}
